const getLevel = (level: string) => {
  switch (level) {
    case 'Freshman':
      return 'Freshman';
    case 'Sophomore':
      return 'Sophomore';
    case 'Junior':
      return 'Junior';
    case 'Senior':
      return 'Senior';
    default:
      return 'Student';
  }
};
const mapVisitorType = (visitorType: string, highSchoolLevelToday: string) => {
  switch (visitorType) {
    case 'hs_student':
      return `HS ${getLevel(highSchoolLevelToday)}`;
    case 'parent_hs_student':
      return `HS ${getLevel(highSchoolLevelToday)} (Parent)`;
    case 'hs_grad':
      return 'HS Grad';
    case 'parent_hs_grad':
      return 'HS Grad (Parent)';
    case 'college_student':
      return 'College Student';
    case 'parent_college_student':
      return 'College Student (Parent)';
    case 'college_grad':
      return 'College Grad';
    case 'parent_college_grad':
      return 'College Grad (Parent)';
    case 'adult_learner':
      return 'Adult Learner';
    case 'parent_adult_learner':
      return 'Adult Learner (Parent)';
    case 'middle_school':
      return 'Middle Schooler';
    case 'parent_middle_school':
      return 'Middle Schooler (Parent)';

    case 'current_student':
      return 'Current Student';
    case 'alumni':
      return 'Alumnus';
    case 'faculty':
      return 'Faculty';
    case 'counselor':
      return 'Guidance Counselor';
    case 'veteran':
      return 'Veteran';
    default:
      return 'Other';
  }
};

export default mapVisitorType;
